var React = require('react');

function CloseSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1 6.9c-.4-.4-1-.4-1.4 0L12 10.6 8.3 6.9c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.7 3.7-3.7 3.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.7-3.7 3.7 3.7c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L13.4 12l3.7-3.7c.4-.4.4-1 0-1.4z"}));
}

CloseSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseSmall;

CloseSmall.default = CloseSmall;
